import * as React from 'react'
import { FC } from 'react'

import { EmbroideryFormKind } from '../../../../containers/EmbroideryService/types'
import { DTCLogoEmbroideryForm } from '../../forms/DTCLogoEmbroideryForm'
import { IconEmbroideryForm } from '../../forms/IconEmbroideryForm'
import { IFormProps } from '../../forms/IFormProps'
import { LogoEmbroideryForm } from '../../forms/LogoEmbroideryForm'
import { TextEmbroideryForm } from '../../forms/TextEmbroideryForm'

const formsByKind: Record<EmbroideryFormKind, FC<IFormProps>> = {
  ICON_ONLY: IconEmbroideryForm,
  TEXT_ONLY: TextEmbroideryForm,
  LOGO_ONLY: LogoEmbroideryForm,
  LOGO_SETUP: DTCLogoEmbroideryForm,
  ADD_LOGO: DTCLogoEmbroideryForm,
}

export const EmbroideryForm: FC<IFormProps & { formKind: EmbroideryFormKind }> = props => {
  const Form: FC<IFormProps> = (function () {
    return formsByKind[props.formKind]
  })()

  return <Form {...props} />
}
